var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"futurelayer-icon-and-warning-wrapper"},[_c('FutureLayerLogoMenu'),(_vm.shouldShowBadge)?_c('FutureLayerDaysRemainingBadge'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }